import React, { useState } from "react";
import PageTitle from "components/PageTitle/PageTitle";
import {
  Button,
  Chip,
  Grid,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import CachedIcon from "@material-ui/icons/Cached";
import AddIcon from "@material-ui/icons/Add";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";

import { useHistory } from "react-router-dom";
import { getRoleName } from "utils/roleNameGetter";
import routes from "routes";
import logo from "images/logoPagesRS.jpg";

// styles
import useStyles from "./styles";

import { format } from "date-fns";
import { dbDelete, dbDisableEnable, dbGet } from "utils/DBFetchers";
import CustomMUIDataTable from "components/MUIDatatable/CustomMUIDataTablev2";

// roles
import { hidedRoles, roleTranslation, reverseRoleTranslation } from "pages/users/roles/utils";

var apiUri = process.env.REACT_APP_API_URI;

export default function UsersPage() {
  const [deleteUserOpen, setDeleteUserOpen] = React.useState(false);
  const [userToDelete, setUserToDelete] = React.useState({ id: "", name: "" });
  const handleDeleteUserOpen = (userId, username) => {
    setDeleteUserOpen(true);
    setUserToDelete({ id: userId, name: username });
  };
  const handleDeleteUserClose = () => {
    setDeleteUserOpen(false);
  };
  const handleDeleteUser = () => {
    setDeleteUserOpen(false);
    dbDelete(`users/${userToDelete.id}`);
    setTimeout(() => {
      setTableData([]);
      getResults("users");
    }, 700);
  };

  const [disableUserOpen, setDisableUserOpen] = React.useState(false);
  const [userToDisable, setUserToDisable] = React.useState({
    id: "",
    name: "",
    command: "",
  });
  const handleDisableUserOpen = (userId, username, enabled) => {
    setDisableUserOpen(true);
    setUserToDisable({
      id: userId,
      name: username,
      command: enabled ? "disable" : "enable",
    });
  };
  const handleDisableUserClose = () => {
    setDisableUserOpen(false);
  };
  const handleDisableUser = () => {
    setDisableUserOpen(false);
    dbDisableEnable("users", userToDisable.id, userToDisable.command);
    setTimeout(() => {
      getResults("users");
    }, 700);
  };

  const history = useHistory();
  // EDIT USER
  const RedirectToEditUser = (user) => {
    history.push(routes.usersEditUser, { userId: user });
  };
  // NEW USER
  const RedirectToNewUser = () => {
    history.push(routes.usersNewUser);
  };

  const IS_ENABLED_POS = 1;
  const IS_DISABLE_POS = 1;
  const USERNAME_POS = 2;
  const ROLE_POS = 3;
  const USER_ID_POS = 7;
  const IS_VISIBLE_POS = 9;

  const [availableRoles, setAvailableRoles] = React.useState([]);

  React.useEffect(() => {
    dbGet("roles")
      .then((data) => {
        var roleNames = data.map(role => {
          return role.name in roleTranslation
            ? roleTranslation[role.name]
            : role.name
        });
        
        roleNames = getRoleName() !== "super_admin"
          ? roleNames.filter((x) => {
              return (!hidedRoles.has(x));
            })
          : roleNames
        
        setAvailableRoles(roleNames);
      })
      .catch((err) => {
        console.error("Error fetching roles!");
      });
  }, []);

  const columns = [
    {
      name: " ",
      options: {
        download: false,
        filter: false,
        sort: false,
        setCellHeaderProps: () => {
          return { style: { fontWeight: "bold", minWidth: 190, width: 190 } };
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <Tooltip title="Editar">
                <IconButton
                  color="primary"
                  aria-label="upload picture"
                  component="span"
                  size="small"
                  className={classes.onlyButtonSpacing}
                  onClick={() => {
                    RedirectToEditUser(tableMeta.rowData[USER_ID_POS]); // user_id
                  }}
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
              {(getRoleName() === "super_admin" || getRoleName() === "admin") && (
                <>
                  <Tooltip title="Eliminar">
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      size="small"
                      className={classes.onlyButtonSpacing}
                      onClick={() => {
                        handleDeleteUserOpen(
                          tableMeta.rowData[USER_ID_POS], // user_id
                          tableMeta.rowData[USERNAME_POS], // username
                        );
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Activar/Desactivar">
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="span"
                      size="small"
                      className={classes.onlyButtonSpacing}
                      onClick={() => {
                        handleDisableUserOpen(
                          tableMeta.rowData[USER_ID_POS], // user_id
                          tableMeta.rowData[USERNAME_POS], // username
                          tableMeta.rowData[IS_DISABLE_POS], // is_disabled
                        );
                      }}
                    >
                      <CachedIcon />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </>
          );
        },
      },
    },
    {
      name: "Estado",
      options: {
        filter: true,
        filterOptions: { names: ["Activo", "Inactivo"]},
        setCellHeaderProps: () => {
          return { style: { fontWeight: "bold" } };
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              label={tableMeta.rowData[1]} // estado
              classes={{
                root: tableMeta.rowData[IS_ENABLED_POS] // is_enabled
                  ? classes.success
                  : classes.secondary,
              }}
            />
          );
        },
      },
    },
    {
      name: "Usuario",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Rol",
      options: {
        filter: true,
        filterOptions: {
          names: availableRoles,
        },
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    // {
    //   name: "Farmacia",
    //   options: {
    //     filter: false,
    //     setCellHeaderProps: () => ({
    //       style: { fontWeight: "bold", whiteSpace: "nowrap" },
    //     }),
    //     setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    //   },
    // },

    // {
    //   name: "Grupo",
    //   options: {
    //     filter: false,
    //     setCellHeaderProps: () => ({
    //       style: { fontWeight: "bold", whiteSpace: "nowrap" },
    //     }),
    //     setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    //   },
    // },
    // {
    //   name: "Distribuidor",
    //   options: {
    //     filter: false,
    //     setCellHeaderProps: () => ({
    //       style: { fontWeight: "bold", whiteSpace: "nowrap" },
    //     }),
    //     setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    //   },
    // },
    // {
    //   name: "KAM",
    //   options: {
    //     filter: false,
    //     display: getRoleName() === "super_admin" ? true : false,
    //     setCellHeaderProps: () => ({
    //       style: { fontWeight: "bold", whiteSpace: "nowrap" },
    //     }),
    //     setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
    //   },
    // },
    {
      name: "Último ingreso",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
        sortCompare: (order) => {
          return (a, b) => {
            var timeA = a.data.slice(11).split(":");
            var timeB = b.data.slice(11).split(":");
            var dateSplitA = a.data.slice(0, 10).split("/");
            var dateSplitB = b.data.slice(0, 10).split("/");
            const dateA = new Date(
              dateSplitA[2],
              dateSplitA[1],
              dateSplitA[0],
              timeA[0],
              timeA[1],
            ).getTime();
            const dateB = new Date(
              dateSplitB[2],
              dateSplitB[1],
              dateSplitB[0],
              timeB[0],
              timeB[1],
            ).getTime();
            return (dateA < dateB ? -1 : 1) * (order === "desc" ? 1 : -1);
          };
        },
      },
    },
    {
      name: "Email",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Apellido y nombre",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    { name: "Id", options: { display: "excluded", filter: false } },
    { name: "Disabled", options: { display: "excluded", filter: false } },
  ];

  var classes = useStyles();
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [count, setCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState("");
  const [filters, setFilters] = useState({
    statuses: [],
    roles: [],
  });
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500); // wait 500ms
  
    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  const changePage = (page) => {
    setCurrentPage(page);
  }

  const changeRowsPerPage = (rows) => {
    setPageSize(rows);
    setCurrentPage(0);
  }

  const handleFilterChange = (column, filterList, type) => {
    if (type === "reset") {
      setFilters({ statuses: [], roles: [] });
      setCurrentPage(0);
      return;
    }
    
    const newFilters = { ...filters };
  
    if (column === "Estado") {
      newFilters.statuses = filterList[IS_ENABLED_POS] || [];

    } else if (column === "Rol") {
      const translatedRoles = filterList[ROLE_POS].map(role => {
        role = role.replace(/\s/g, ""); // remove whitespaces
        return role in reverseRoleTranslation
          ? reverseRoleTranslation[role]
          : role;
      });
      newFilters.roles = translatedRoles || [];
    }
  
    setCurrentPage(0);
    setFilters(newFilters);
  };

  const handleSortChange = (sortColumn, sortDirection) => {
    setSortColumn(sortColumn);
    setSortDirection(sortDirection);
  };
  
  const fillTable = (data) => {
    if (!data) return;
    setIsLoading(true);
    dbGet("roles")
    .then((roleData) => {
      var roles = {};
      var users_data = data.users;
      setCurrentPage(data.page - 1);  // backend starts at 1
      setPageSize(data.page_size);
      setCount(data.total_users);
      setTotalPages(data.total_pages);

      roleData.forEach((role) => (roles[role.id] = role.name));
      var tableData = users_data.map((row) => [
        "",
        row.is_enabled ? "Activo" : "Inactivo",
        row.username,
        roles[row.role_id] in roleTranslation
          ? roleTranslation[roles[row.role_id]]
          : roles[row.role_id],
        // row.pharmacy && Object.keys(row.pharmacy).length !== 0
        //   ? `${row.pharmacy.name} - ${row.pharmacy.code}`
        //   : "",
        // row.pharma_group && Object.keys(row.pharma_group).length !== 0
        //   ? row.pharma_group.name
        //   : "",
        // row.distributor && Object.keys(row.distributor).length !== 0
        //   ? row.distributor.name
        //   : "",
        // row.kam && Object.keys(row.kam).length !== 0 ? row.kam.name : "",
        format(new Date(row.last_activity_at), "dd/MM/yyyy HH:mm"),
        row.email,
        `${row.lastname ? row.lastname : ""} ${row.name ? row.name : ""}`,
        row.id,
        row.is_enabled,
        row.is_visible,
      ]);
      setTableData(tableData);
      setIsLoading(false);
    })
      .catch((error) => {
        snackbarOpen("error", "Error al intentar cargar la tabla");
        setIsLoading(false);
      });
  };

  var [isLoading, setIsLoading] = useState(false);
  const getResults = (category) => {
    setIsLoading(true);
    dbGet(category)
      .then((data) => {
        fillTable(data);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const makePaginationQueryParams = () => {
    const params = new URLSearchParams();
    params.append("page", currentPage + 1); // backend starts at 1
    params.append("page_size", pageSize);

    if (filters.statuses.length > 0) {
      params.append("status", filters.statuses.join(","));
    }
    if (filters.roles.length > 0) {
      params.append("roles", filters.roles.join(","));
    }
    if (debouncedSearch) {
      params.append("search", debouncedSearch);
    }
    if (sortColumn) {
      params.append("order_by", sortColumn);
      params.append("order_dir", sortDirection);
    }
    params.append("role_name", getRoleName());
    return params;
  };

  React.useEffect(() => {
    const params = makePaginationQueryParams();
    getResults(`/users/v2?${params.toString()}`);
  }, [pageSize, currentPage, filters, debouncedSearch, sortColumn, sortDirection]);

  const handleDownload = () => {
    const params = makePaginationQueryParams();

    setIsLoading(true);
    dbGet(`/users/upload-file-to-bucket?${params.toString()}`)
      .then((response) => {
        setTimeout(updateProgress.bind(null, response.id), 3000);
      })
      .catch((error) => {
        snackbarOpen("error", "Error al intentar realizar la descarga");
        setIsLoading(false);
    });
    return false;
  };

  const updateProgress = (id) => {
    dbGet(`request_checker/status?id=${id}`)
      .then((response) => {
        if (response.status === "Completed") {
          dbGet(`/users/download?id=${id}&desired_filename=Usuarios.xlsx`)
            .then((data) => {
              const fileUrl = data?.data;
              if (fileUrl) {
                window.open(fileUrl, "_blank");
              } else {
                snackbarOpen("error", "No se recibió un archivo para descargar");
              }
            })
            .catch((error) => {
              snackbarOpen("error", "Error al intentar realizar la descarga");
          });

        } else if (!response.error_status && response.status !== "Failure") {
          setTimeout(updateProgress.bind(null, id, response), 2000);
        
        } else {
          snackbarOpen("error", "Error al intentar realizar la descarga");
        }
      })
      .catch((error) => {
        snackbarOpen("error", "Error al intentar realizar la descarga");
      });
      setIsLoading(false);
    };
  

  return (
    <>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <Dialog open={deleteUserOpen} onClose={handleDeleteUserClose}>
        <DialogTitle>{`¿Eliminar el usuario ${userToDelete.name}?`}</DialogTitle>
        <DialogActions className={classes.popupDivCenter}>
          <Button
            onClick={handleDeleteUserClose}
            color="primary"
            variant="contained"
            className={classes.popupButtonSpacing}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleDeleteUser}
            variant="contained"
            autoFocus
            className={classes.popupButtonSpacingDelete}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={disableUserOpen} onClose={handleDisableUserClose}>
        <DialogTitle>{`${
          userToDisable.command === "enable" ? "Activar" : "Desactivar"
        } el usuario ${userToDisable.name}?`}</DialogTitle>
        <DialogActions className={classes.popupDivCenter}>
          <Button
            onClick={handleDisableUserClose}
            color="primary"
            variant="contained"
            className={classes.popupButtonSpacing}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleDisableUser}
            color="secondary"
            variant="contained"
            autoFocus
            className={
              userToDisable.command === "enable"
                ? classes.popupButtonSpacingEnable
                : classes.popupButtonSpacing
            }
          >
            {userToDisable.command === "enable" ? "Activar" : "Desactivar"}
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <PageTitle
          title="Usuarios"
          // button={
          //   <img src={logo} alt="logo" className={classes.logotypeImage} />
          // }
        />
      </div>
      <div>
        <Button
          color="primary"
          variant="contained"
          size="large"
          onClick={RedirectToNewUser}
          startIcon={<AddIcon />}
        >
          Añadir
        </Button>
      </div>

      {isLoading && (
        <div>
          <Typography variant="h4" className={classes.loaderText}>
            Cargando datos
          </Typography>
          <LinearProgress size={40} className={classes.loader} />
        </div>
      )} 
      {(
        <Grid
          style={{ display: "flex", margin: 0 }}
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          spacing={4}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ marginTop: "2%" }}>
              <CustomMUIDataTable
                title="Usuarios"
                data={
                  tableData
                  // getRoleName() !== "super_admin"
                  //   ? tableData.filter((x) => {
                  //       // BE CAREFULL, THIS HAS TO FILTER TRANSLATED ROLES
                  //       return (
                  //         !hidedRoles.has(x[ROLE_POS]) &&
                  //         x[IS_VISIBLE_POS] !== false
                  //       );
                  //     })
                  //   : tableData
                }
                columns={columns}
                filterStart={1}
                filterEnd={11}
                count={count}
                page={currentPage}
                totalPages={totalPages}
                rowsPerPage={pageSize}
                changePage={changePage}
                changeRowsPerPage={changeRowsPerPage}
                // onDownload={handleDownload}
                options={{
                  pagination: true,
                  onFilterChange: handleFilterChange,
                  filterList: [
                    filters.statuses,
                    filters.roles,
                  ],
                  onSearchChange: (searchText) => {
                    setSearchQuery(searchText);
                    setCurrentPage(0);
                  },
                  onColumnSortChange: handleSortChange,
                  onDownload: handleDownload,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
